<h1 class="p-2 text-center">Thank you for signing up!</h1>
<h2 class="p-2 text-center">To complete your registration and activate your account, please check your email, including
    the spam folder, for our verification message. Click on the link provided in the email to verify your account.</h2>